import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isTableView: false,
  isEditing: false,
  // columns: [
  //   'status',
  //   'provider',
  //   'date',
  //   'patient',
  //   'case',
  //   'category',
  //   'total',
  //   'patient.phone',
  //   'session_type',
  //   'location',
  //   'comment',
  //   'actions',
  // ],
};

const slice = createSlice({
  name: 'leadTable',
  initialState,
  reducers: {
    setIsTableView: (state, action) => ({
      ...state,
      isTableView: action.payload,
    }),
    setIsEditing: (state, action) => ({
      ...state,
      isEditing: action.payload,
    }),
    // setColumns: (state, action) => ({
    //   ...state,
    //   columns: action.payload || initialState.selectedColumns,
    // }),
  }
});

export const {
  setIsTableView,
  setIsEditing,
} = slice.actions;
    
export default slice.reducer;